<template>
   <div class="sidenav-container">
      <div class="side-nav">
         <div ref="sectionNameContainer" class="section-name-container">
            <span ref="sectionName" class="section-name">INTRO</span>
         </div>
         <SideNavButton
                 v-on:click.prevent.native="switchToIntro"
                 :scrollTo="-1"
                 :isActive="$store.state.view === 'intro'"
         ></SideNavButton>
         <SideNavButton
                 v-for="(article, index) in articles"
                 :key="article.number"
                 v-on:click.prevent.native="switchToArticle(article.number)"
                 :scrollTo="article.number - 1"
                 :isActive="$store.state.view === 'articles' && index === $store.state.activeArticleIdx"
         ></SideNavButton>
         <SideNavButton
                 v-on:click.prevent.native="switchToConclusions"
                 :scrollTo="articles.length"
                 :isActive="$store.state.view === 'conclusions'"
         ></SideNavButton>
      </div>
   </div>
</template>

<script>
    import content from './../content'
    import {bus} from './../consts'
    import 'TweenMax'
    import SideNavButton from './SideNavButton'

    export default {
        name: 'SideNavigation',
        props: [
            'articlesActive'
        ],
        components: {
            SideNavButton
        },
        data() {
            return {
                articles: content.articles,
                links: null
            }
        },
        methods: {
            switchToIntro() {
                if (this.$store.state.view !== 'intro') {
                    this.$store.commit('clickedIntroNavBtn', true);
                    this.$store.commit('setView', 'intro');
                    this.$store.commit('allowMagic', false);
                    TweenMax.set(window, {scrollTo: {y: 0, autoKill: false}});
                    this.allowMagicAfterDelay();
                }
            },
            switchToArticle(num) {
                bus.$emit('articlesEnterAnim');
                this.$store.commit('allowMagic', false);
                this.$store.commit('setActiveArticleIdx', num - 1);
                TweenMax.set(window, {scrollTo: {y: '#section-' + num, autoKill: false}});
                this.allowMagicAfterDelay();
            },
            switchToConclusions() {
                this.$store.commit('setView', 'conclusions');
                TweenMax.set(window, {scrollTo: {y: '.articles-end', autoKill: false}});
                this.allowMagicAfterDelay();
            },
            allowMagicAfterDelay() {
                setTimeout(() => {
                    this.$store.commit('allowMagic', true);
                }, 800);
            }
        },
        mounted() {
            // Push array of side nav links into data object
            this.links = document.querySelectorAll('.side-nav a')

            bus.$on('showSideNavTitle', (num) => {
                this.$refs.sectionName.innerText = content.mobileTitles[num + 1]
                this.$refs.sectionNameContainer.classList.add('show')
            })

            bus.$on('hideSideNavTitle', () => {
                this.$refs.sectionNameContainer.classList.remove('show')
            })
        }
    }
</script>

<style lang="scss">
   @import '../scss/the-goods';

   $sideNavWidth : 41px;
   $sideNavRadius : $sideNavWidth / 2;

   .sidenav-container {
      position    : fixed;
      left        : 20px;
      top         : 0;
      height      : 100%;
      display     : flex;
      align-items : center;
      z-index     : 10;
      animation   : fadein 2s;
      @include hidden-xs;

      .landscape-mode & {
         @include screen-xs-sm {
            left        : 10px;
            align-items : flex-end;
         }
      }

      .side-nav {
         width          : $sideNavWidth;
         background     : white;
         border-radius  : $sideNavRadius;
         display        : flex;
         flex-direction : column;
         align-items    : center;
         opacity        : .9;
         position       : relative;

         .landscape-mode & {
            @include screen-xs-sm {
               width         : 30px;
               border-radius : 15px;
               margin-bottom : 10px;
            }
         }

         .section-name-container {
            position       : absolute;
            top            : -85px;
            transform      : rotate(-90deg) translateX(5px);
            color          : white;
            letter-spacing : .3em;
            font-size      : 12px;
            opacity        : 0;
            pointer-events : none;
            transition     : opacity .2s;
            width          : 120px;

            .section-name {
               text-align     : left;
               text-transform : uppercase;
            }

            &.show {
               opacity    : .7;
               transform  : rotate(-90deg) translateX(0px);
               transition : opacity .1s, transform .07s;
            }
         }
      }
   }

   .onIE {
      .sidenav-container .side-nav .section-name-container {
         display : none;
      }
   }
</style>



// WEBPACK FOOTER //
// src/components/SideNavigation.vue